const AUTH_TOKEN_KEY = 'auth_token'

/** Read bearer token from session (tab) or persistent browser storage. */
export function getAuthToken(): string | null {
  if (typeof window === 'undefined') return null
  const raw = sessionStorage.getItem(AUTH_TOKEN_KEY) || localStorage.getItem(AUTH_TOKEN_KEY)
  const trimmed = raw?.trim()
  return trimmed || null
}

/**
 * Persist token across browser restarts until explicit logout.
 * Always write localStorage (sessionStorage alone dies when all tabs close).
 * `rememberMe` is kept for callers / API TTL; storage is always durable.
 */
export function setAuthToken(token: string, _rememberMe = true): void {
  clearAuthToken()
  const normalized = token.trim()
  if (!normalized) return
  sessionStorage.setItem(AUTH_TOKEN_KEY, normalized)
  localStorage.setItem(AUTH_TOKEN_KEY, normalized)
}

/**
 * Ensure the bearer token is in localStorage (survives tab/browser close).
 * Safe to call on every boot / resume.
 */
export function ensurePersistentAuthToken(): void {
  if (typeof window === 'undefined') return
  const token = getAuthToken()
  if (!token) return
  localStorage.setItem(AUTH_TOKEN_KEY, token)
  sessionStorage.setItem(AUTH_TOKEN_KEY, token)
}

/** Remove token from both storages. */
export function clearAuthToken(): void {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(AUTH_TOKEN_KEY)
  localStorage.removeItem(AUTH_TOKEN_KEY)
}

export function hasAuthToken(): boolean {
  return Boolean(getAuthToken())
}
